export default __webpack_public_path__ + "static/media/mobile_confirmation_balloon.cbf54088.svg";